import React from "react";
import { useLocation } from "react-router-dom";
import styles from './WhatsAppButton.module.css';
import { KNOWN_ROUTES } from '../../routesConfig';

function WhatsAppButton() {
  const location = useLocation();

  if (
    location.pathname.startsWith('/panel-admin')
    || location.pathname === '/confirmar-correo'
    || !KNOWN_ROUTES.includes(location.pathname)
  ) return null;

  return (
    <a
      href="https://wa.me/573197618029"
      target="_blank"
      rel="noopener noreferrer"
      className={styles.whatsappButton}
      aria-label="Escríbenos por WhatsApp"
    >
      <img src="/img/Whatsapp.png" alt="" aria-hidden="true" />
    </a>
  );
}

export default WhatsAppButton;
